import React, { useEffect } from "react";
import HomeReviews from "../../components/homepage-components/HomeReviews";
import Faq from "../../components/universal-components/Faq";
import Hero from "../../components/Hero";
import Intro from "../../components/Intro";
import ContentLeft from "../../components/ContentLeft";
import ContentRight from "../../components/ContentRight";
import CallToAction from "../../components/CallToAction";
import { housingAsssociationContent } from "../../page-content/commercial-content/housingAssociationContent";

const HousingAssociation = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Hero data={housingAsssociationContent} />
      <Intro data={housingAsssociationContent} />
      <ContentLeft data={housingAsssociationContent} />
      <ContentRight data={housingAsssociationContent} />
      <CallToAction data={housingAsssociationContent} />
      <HomeReviews />
      <Faq />
    </>
  );
};

export default HousingAssociation;
